var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-content"},[(_vm.brandDashboard && _vm.brandDashboard.length)?_c('iframe',{staticStyle:{"height":"100vh","width":"100%"},attrs:{"src":("https://bionix.cixxonia.com" + (_vm.brandDashboard[0].full_url))}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }